"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SLOT_INJECTION_LIMIT_DEFAULTS = exports.SUPPORTED_PLUGINS = exports.subsequentSlotThreshold = exports.finalSlotEmbedCharacterEquivalency = exports.embedCharacterEquivalency = exports.EMBED_CARD_MARGIN = exports.lineBreakEquivalency = exports.WORDPRESS_BLOCK_CHARACTER_COUNT = exports.ESTIMATED_LINE_LENGTH = exports.CHARACTER_COUNT_SCALE = exports.EMBED_SELECTOR = exports.viewPorts = void 0;
const tempest_common_1 = require("tempest-common");
// Copied from https://github.com/themaven-net/tempest-phoenix/blob/bc8ab5374405f1683a20f9db3207e5f7e284fdb1/server/web/template-modules/tml/plugins/adContainers.js#L7-L16.
exports.viewPorts = ['A', 'B', 'C', 'D'];
exports.EMBED_SELECTOR = [
    '.tml-image',
    '.tml-external-provider',
    '.m-embed',
    '.m-video',
    '.m-longform-gallery',
    '.m-gallery-invite',
    '.m-embed-card',
    '.wp-block-embed',
    '.wp-block-image',
].join(',');
exports.CHARACTER_COUNT_SCALE = tempest_common_1.contentStats.CHARACTER_HEIGHT_SCALE;
exports.ESTIMATED_LINE_LENGTH = tempest_common_1.contentStats.ESTIMATED_LINE_LENGTH;
exports.WORDPRESS_BLOCK_CHARACTER_COUNT = {
    default: {
        A: 200,
        B: 200,
        C: 200,
        D: 200,
    },
};
// contentStats.WORDPRESS_BLOCK_CHARACTER_COUNT;
exports.lineBreakEquivalency = exports.ESTIMATED_LINE_LENGTH;
exports.EMBED_CARD_MARGIN = tempest_common_1.contentStats.legacyCharacterCount.EMBED_CARD_MARGIN;
exports.embedCharacterEquivalency = tempest_common_1.contentStats.legacyCharacterCount.embedCharacterEquivalency;
exports.finalSlotEmbedCharacterEquivalency = tempest_common_1.contentStats.legacyCharacterCount.finalAdEmbedCharacterEquivalency;
exports.subsequentSlotThreshold = 1;
exports.SUPPORTED_PLUGINS = [
    'Keystone',
    'InContentAd',
    'Spot',
    'FallbackVideo',
    'Newsletters',
    'Sellwild',
];
exports.SLOT_INJECTION_LIMIT_DEFAULTS = {
    A: {
        initial: 500,
        subsequent: 1500,
        final: 0,
    },
    B: {
        initial: 1500,
        subsequent: 4000,
        final: 2000,
    },
    C: {
        initial: 1500,
        subsequent: 4000,
        final: 2000,
    },
    D: {
        initial: 1500,
        subsequent: 4000,
        final: 2000,
    },
};
//# sourceMappingURL=constants.js.map